const formatDate = (date: Date, options?: { month?: 'short' | 'long' | 'numeric' | '2-digit' | 'narrow' }) => {
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: options?.month || 'short',
    day: 'numeric',
  });
};

export { formatDate };
